var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { Store, select } from '@ngrx/store';
import { of } from 'rxjs';
import { QueueAlertAction, AlertType, GoAction } from '@app/core';
import { selectUserDetail } from './user-details.selectors';
import { filter, map } from 'rxjs/operators';
import { LoadingUserDetailsAction } from './user-details.actions';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
var UserDetailsFacadeService = /** @class */ (function () {
    function UserDetailsFacadeService(store) {
        this.store = store;
        this.loadableDetails$ = of();
        this.user$ = of();
        this.userRoles$ = of();
        this.userGroups$ = of();
    }
    UserDetailsFacadeService.prototype.initialize = function (username) {
        var _this = this;
        this.store.dispatch(new LoadingUserDetailsAction(username));
        var userDetails$ = this.store.pipe(select(selectUserDetail(username)), filter(function (data) { return !!data; }));
        this.user$ = userDetails$.pipe(map(function (data) { return data.user; }));
        this.userRoles$ = userDetails$.pipe(map(function (data) { return data.user && data.user.roles || []; }), map(function (roles) { return _this.removeDuplicates(roles); }));
        this.userGroups$ = userDetails$.pipe(map(function (data) { return data.user && data.user.groups || []; }));
    };
    UserDetailsFacadeService.prototype.removeDuplicates = function (list) {
        if (list === void 0) { list = []; }
        var newList = list.reduce(function (acc, item) {
            return (__assign({}, acc, (_a = {}, _a[item.id] = item, _a)));
            var _a;
        }, []);
        return Object.values(newList);
    };
    UserDetailsFacadeService.prototype.removeRoleSucceed = function (removeId) {
        // this.store.dispatch(new RemoveGroupByIdAction(removeId));
        this.store.dispatch(new QueueAlertAction({ alertText: "Role delete succeed.", alertType: AlertType.SUCCESS }));
    };
    UserDetailsFacadeService.prototype.removeRoleFailed = function () {
        this.store.dispatch(new QueueAlertAction({ alertText: "Role delete failed.", alertType: AlertType.ERROR }));
    };
    UserDetailsFacadeService.prototype.addUserRolesSucceed = function (user) {
        this.store.dispatch(new GoAction(['/iam/users', user.username]));
        this.store.dispatch(new QueueAlertAction({ alertText: "Roles add succeed.", alertType: AlertType.SUCCESS }));
    };
    UserDetailsFacadeService.prototype.removeGroupSucceed = function (username) {
        this.store.dispatch(new LoadingUserDetailsAction(username));
        this.store.dispatch(new QueueAlertAction({ alertText: "Role delete succeed.", alertType: AlertType.SUCCESS }));
    };
    UserDetailsFacadeService.prototype.removeGroupFailed = function () {
        this.store.dispatch(new QueueAlertAction({ alertText: "Role delete failed.", alertType: AlertType.ERROR }));
    };
    UserDetailsFacadeService.ngInjectableDef = i0.defineInjectable({ factory: function UserDetailsFacadeService_Factory() { return new UserDetailsFacadeService(i0.inject(i1.Store)); }, token: UserDetailsFacadeService, providedIn: "root" });
    return UserDetailsFacadeService;
}());
export { UserDetailsFacadeService };



// WEBPACK FOOTER //
// ./src/app/access-management/state/user-details/user-details.facade.ts.pre-build-optimizer.js